import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {get} from '../Storage';
import CircularProgress from 'material-ui/CircularProgress';
import {Message} from "mgUiKit";
import {Card, CardHeader, CardText} from 'material-ui/Card';
import KeepAlive from '../KeepAlive';
import MissionsList from '../MissionsList';
// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'WidgetMissionComponent';

var styles = AppSettings.styles;
var _missionsList = [];

class WidgetMission extends React.Component{
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            error: false,
            showLoading: true,
            errorMessage: "",
            opened:false,
        }
        this.loadMissions = this.loadMissions.bind(this);
    }

    componentDidMount() {        
        this.loadMissions();
    }

    loadMissions() {
        if(this.state.opened){
            this.setState({
                error: false,
                errorMessage: "",
                data: [],
                showLoading: true,
                opened:false
            });
            return;
        }
        this.setState({
            showLoading: true,
            opened:true
        });
        //aggiungere nello stato la chiamata
        var url = AppSettings['env'].urlUserBoxTabMissions;
      //  if(_missionsList==0){
            axios.get(url)
                .then(({ data, status, statusText }) => {
                    var showLoading = false;
                    _missionsList=[];                    
                    if (data.errors.length == 0) { 
                        _missionsList=data.missions;                       
                        this.setState({
                            error: false,
                            showLoading: showLoading,
                            data:_missionsList,
                            errorMessage: "",
                            opened:true
                        });
                    } else {
                        this.setState({
                            error: true,
                            data: [],
                            showLoading: showLoading,
                            opened: true,
                            errorMessage: <KeepAlive />
                        });

                    }
                })

                .catch(({ data, status, statusText }) => {
                    this.setState({
                        error: true,
                        showLoading: false,
                        errorMessage: "Errore durante il caricamento",
                        opened: true,
                        data:[]
                    });
                });
        // }else{
        //     this.setState({
        //         error: false,
        //         showLoading: false,
        //         data: _missionsList,
        //         errorMessage: "",
        //         opened:true
        //     });

        // }
    }

    renderWidgetMission(){

       // this.loadMissions();
       
        if(this.state.showLoading){
             return <CircularProgress style={styles.loadingIcon}/>;
         }        
        if(this.state.error){
            return <Message align="center">{this.state.errorMessage}</Message>;
        }        
        return (
            <MissionsList data={this.state.data} />
        );
    } 

    render() {

        var missions = this.state.data;      
        if (AppSettings['perms'].tabMissions )
        {    
            return (
                <div id="mg-missions" className="mg-user-widget">                        
                    { this.renderWidgetMission() }
                </div>
            );
        }else{
            return("");
        }
    }
}
WidgetMission.displayName = componentName;

// PropTypes validation
WidgetMission.propTypes = {
    countMission: PropTypes.number
   
};

// default props
WidgetMission.defaultProps = {
  
};


WidgetMission.contextTypes = {
  
}
export default WidgetMission;